/** Namespace `templates` (Behandlungsnotiz-Vorlagen) — befüllt während der Migration. */
export const templates = {
  de: {
    templates: {
      // Page
      pageTitle: 'Dokumentations-Vorlagen',
      newTemplate: 'Neue Vorlage',
      newTemplateHeading: 'Neue Vorlage',
      searchPlaceholder: 'Suchen ...',
      showArchived: 'Archivierte zeigen',
      loading: 'Lade ...',
      noTemplates: 'Keine Vorlagen.',
      archivedBadge: 'archiviert',
      sectionsAbbr: 'Sek.',
      emptyHint: 'Wähle eine Vorlage links oder lege eine neue an.',

      // Category labels
      categoryProphylaxis: 'Prophylaxe',
      categoryRestorative: 'Konservierend',
      categoryEndodontics: 'Endodontie',
      categoryImplant: 'Implantologie',
      categoryAesthetics: 'Ästhetik',
      categoryConsultation: 'Beratung',
      categoryEmergency: 'Notfall',
      categoryDiagnostic: 'Diagnostik',
      categoryOther: 'Sonstiges',

      // Section types
      sectionTypeSingleChoiceLabel: 'Single Choice (Pillen)',
      sectionTypeSingleChoiceHelper: 'Genau eine Option waehlbar.',
      sectionTypeMultiChoiceLabel: 'Multi Choice (Buttons)',
      sectionTypeMultiChoiceHelper: 'Beliebig viele Optionen waehlbar.',
      sectionTypeToothChartLabel: 'Zahnchart (FDI)',
      sectionTypeToothChartHelper: 'Zahn-Auswahl per Klick.',
      sectionTypeTextFreeformLabel: 'Freitext',
      sectionTypeTextFreeformHelper: 'Textarea mit i18n-Placeholder.',
      sectionTypeChipsIndicationLabel: 'Indikations-Chips',
      sectionTypeChipsIndicationHelper: 'Multi-Select gegen globales Vokabular.',

      // Options editor
      removeOption: 'Option entfernen',
      optionValuePlaceholder: 'value (snake_case)',
      optionLabelPlaceholder: 'Anzeige-Label',
      addOption: 'Option hinzufuegen',

      // Section editor
      moveUp: 'Nach oben',
      moveDown: 'Nach unten',
      removeSection: 'Section entfernen',
      sectionKey: 'Section-Key',
      sectionKeyPlaceholder: 'snake_case_key',
      sectionTypeField: 'Typ',
      sectionLabel: 'Label (Anzeige im Editor)',
      sectionLabelPlaceholder: 'z.B. Mundhygiene',
      docTemplateLabel: 'doc_template (Render-Pattern)',
      docTemplateVars:
        'Variablen: {{single}} (single), {{multi}} (multi/chips), {{tooth}} (tooth), {{text}} (freetext)',
      docTemplatePlaceholder: 'z.B. Mundhygiene {value_label}.',
      options: 'Optionen',
      showDeciduousToggle: 'Milchgebiss-Toggle anzeigen',
      placeholderI18n: 'Placeholder (i18n)',
      placeholderHint: 'Beispieltext, der grau im Feld erscheint ...',

      // Detail form
      langOnlyDeTitle: 'Nur Deutsch anzeigen',
      langAddEsEnTitle: 'ES und EN dazu anzeigen',
      langOnlyDe: 'Nur DE',
      langAll: 'DE · ES · EN',
      restore: 'Wiederherstellen',
      archive: 'Archivieren',
      cancel: 'Abbrechen',
      save: 'Speichern',
      saving: 'Speichert ...',
      slugLabel: 'Slug (URL-Key)',
      slugPlaceholder: 'z.B. pzr-erweitert',
      slugImmutableTitle: 'Slug ist unveraenderlich nach dem Anlegen.',
      categoryLabel: 'Kategorie',
      nameLabel: 'Name (Anzeige)',
      namePlaceholder: 'z.B. Prophylaxe / PZR',
      headerTemplateLabel: 'Header-Template (i18n)',
      headerTemplateVars: 'Variablen: {{title}}, {{practitioner}}, {{patient}}',
      languageDefaultLabel: 'Standardsprache',
      sectionsHeading: 'Sektionen ({{count}})',
      noSections: 'Noch keine Sektion — füge unten eine erste hinzu.',
      pickSectionType: 'Section-Typ auswählen',
      addSection: 'Sektion hinzufügen',
      previewHeading: 'Doku-Vorschau (Demo-Werte)',
      previewEmpty: 'Vorschau erscheint, sobald Slug + Sektionen ausgefüllt sind.',

      // Demo values
      demoFreetext: '(Beispieltext aus Freitext-Section)',

      // Toasts
      errorLoad: 'Vorlagen konnten nicht geladen werden',
      created: 'Vorlage angelegt.',
      updated: 'Vorlage aktualisiert.',
      errorSave: 'Speichern fehlgeschlagen',
      confirmArchive: 'Vorlage archivieren? Bestehende Notizen mit dieser Vorlage bleiben gültig.',
      archived: 'Vorlage archiviert.',
      errorArchive: 'Archivieren fehlgeschlagen',
      unarchived: 'Vorlage wiederhergestellt.',
      errorUnarchive: 'Wiederherstellen fehlgeschlagen',
    },
  },
  es: {
    templates: {
      pageTitle: 'Plantillas de documentación',
      newTemplate: 'Nueva plantilla',
      newTemplateHeading: 'Nueva plantilla',
      searchPlaceholder: 'Buscar ...',
      showArchived: 'Mostrar archivadas',
      loading: 'Cargando ...',
      noTemplates: 'No hay plantillas.',
      archivedBadge: 'archivada',
      sectionsAbbr: 'sec.',
      emptyHint: 'Seleccione una plantilla a la izquierda o cree una nueva.',

      categoryProphylaxis: 'Profilaxis',
      categoryRestorative: 'Conservadora',
      categoryEndodontics: 'Endodoncia',
      categoryImplant: 'Implantología',
      categoryAesthetics: 'Estética',
      categoryConsultation: 'Consulta',
      categoryEmergency: 'Urgencia',
      categoryDiagnostic: 'Diagnóstico',
      categoryOther: 'Otros',

      sectionTypeSingleChoiceLabel: 'Selección única (píldoras)',
      sectionTypeSingleChoiceHelper: 'Se puede elegir exactamente una opción.',
      sectionTypeMultiChoiceLabel: 'Selección múltiple (botones)',
      sectionTypeMultiChoiceHelper: 'Se pueden elegir varias opciones.',
      sectionTypeToothChartLabel: 'Odontograma (FDI)',
      sectionTypeToothChartHelper: 'Selección de dientes con un clic.',
      sectionTypeTextFreeformLabel: 'Texto libre',
      sectionTypeTextFreeformHelper: 'Área de texto con marcador de posición i18n.',
      sectionTypeChipsIndicationLabel: 'Etiquetas de indicación',
      sectionTypeChipsIndicationHelper: 'Selección múltiple contra el vocabulario global.',

      removeOption: 'Eliminar opción',
      optionValuePlaceholder: 'value (snake_case)',
      optionLabelPlaceholder: 'Etiqueta visible',
      addOption: 'Añadir opción',

      moveUp: 'Hacia arriba',
      moveDown: 'Hacia abajo',
      removeSection: 'Eliminar sección',
      sectionKey: 'Clave de sección',
      sectionKeyPlaceholder: 'snake_case_key',
      sectionTypeField: 'Tipo',
      sectionLabel: 'Etiqueta (visible en el editor)',
      sectionLabelPlaceholder: 'p. ej., Higiene bucal',
      docTemplateLabel: 'doc_template (patrón de renderizado)',
      docTemplateVars:
        'Variables: {{single}} (single), {{multi}} (multi/chips), {{tooth}} (tooth), {{text}} (freetext)',
      docTemplatePlaceholder: 'p. ej., Higiene bucal {value_label}.',
      options: 'Opciones',
      showDeciduousToggle: 'Mostrar selector de dentición temporal',
      placeholderI18n: 'Marcador de posición (i18n)',
      placeholderHint: 'Texto de ejemplo que aparece en gris en el campo ...',

      langOnlyDeTitle: 'Mostrar solo alemán',
      langAddEsEnTitle: 'Mostrar también ES y EN',
      langOnlyDe: 'Solo DE',
      langAll: 'DE · ES · EN',
      restore: 'Restaurar',
      archive: 'Archivar',
      cancel: 'Cancelar',
      save: 'Guardar',
      saving: 'Guardando ...',
      slugLabel: 'Slug (clave URL)',
      slugPlaceholder: 'p. ej., pzr-ampliada',
      slugImmutableTitle: 'El slug no se puede modificar tras la creación.',
      categoryLabel: 'Categoría',
      nameLabel: 'Nombre (visible)',
      namePlaceholder: 'p. ej., Profilaxis / Limpieza',
      headerTemplateLabel: 'Plantilla de cabecera (i18n)',
      headerTemplateVars: 'Variables: {{title}}, {{practitioner}}, {{patient}}',
      languageDefaultLabel: 'Idioma predeterminado',
      sectionsHeading: 'Secciones ({{count}})',
      noSections: 'Aún no hay secciones — añada la primera abajo.',
      pickSectionType: 'Seleccionar tipo de sección',
      addSection: 'Añadir sección',
      previewHeading: 'Vista previa de documentación (valores de ejemplo)',
      previewEmpty: 'La vista previa aparece en cuanto se rellenan el slug y las secciones.',

      demoFreetext: '(Texto de ejemplo de la sección de texto libre)',

      errorLoad: 'No se pudieron cargar las plantillas',
      created: 'Plantilla creada.',
      updated: 'Plantilla actualizada.',
      errorSave: 'Error al guardar',
      confirmArchive: '¿Archivar la plantilla? Las notas existentes con esta plantilla siguen siendo válidas.',
      archived: 'Plantilla archivada.',
      errorArchive: 'Error al archivar',
      unarchived: 'Plantilla restaurada.',
      errorUnarchive: 'Error al restaurar',
    },
  },
};
